import React from 'react';
import {
  Card,
  CardContent,
  Typography,
  List,
  ListItemButton,
  ListItemText,
  Box,
} from '@mui/material';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';

interface AlertaItem {
  titulo: string;
  descricao: string;
  eixo?: string;
  tipo: 'atencao' | 'oportunidade';
}

interface AlertaCardProps {
  titulo: string;
  icon: React.ReactNode;
  items: AlertaItem[];
  onItemClick?: (eixo: string) => void;
  emptyText?: string;
}

const AlertaCard: React.FC<AlertaCardProps> = ({
  titulo,
  icon,
  items,
  onItemClick,
  emptyText = 'Nenhum item encontrado.',
}) => {
  const visible = items.slice(0, 5);

  return (
    <Card variant="outlined">
      <CardContent sx={{ pb: 0 }}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 1 }}>
          {icon}
          <Typography variant="subtitle1" fontWeight={600}>
            {titulo}
          </Typography>
        </Box>
      </CardContent>
      {visible.length === 0 ? (
        <Box sx={{ px: 2, pb: 2 }}>
          <Typography variant="body2" color="text.secondary">
            {emptyText}
          </Typography>
        </Box>
      ) : (
        <List disablePadding>
          {visible.map((item, idx) => {
            const clickable = !!item.eixo && !!onItemClick;
            return (
              <ListItemButton
                key={idx}
                disabled={!clickable}
                onClick={() => clickable && onItemClick!(item.eixo!)}
                sx={{
                  py: 1,
                  px: 2,
                  borderTop: idx > 0 ? '1px solid' : 'none',
                  borderColor: 'divider',
                  '&.Mui-disabled': { opacity: 1 },
                }}
              >
                <ListItemText
                  primary={
                    <Typography variant="body2" fontWeight={600}>
                      {item.titulo}
                    </Typography>
                  }
                  secondary={
                    <Typography variant="caption" color="text.secondary">
                      {item.descricao}
                    </Typography>
                  }
                />
                {clickable && (
                  <ChevronRightIcon fontSize="small" sx={{ color: 'text.secondary', ml: 1 }} />
                )}
              </ListItemButton>
            );
          })}
        </List>
      )}
    </Card>
  );
};

export default AlertaCard;
